// Nav entry of Settings (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'settings',
  path: '/settings',
  icon: 'settings',
  group: 'app',
  phone: 'more',
  order: 1500,
  load: () => import('./Settings'),
});
